'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('vendor-list', {
      url: '/vendor/list',
      template: '<vendor-list></vendor-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/vendor/vendor-list.routes.js